import axios from 'axios';

let localizationInterceptor: any;

/**
 * Sets an interceptor for all `axios.get` requests and adds a query param with the selected language
 * @param language The selected language to send to all requests
 */
export const setLocalizationInterceptor = (language: string) => {
  if (language.trim().length > 0) {
    if (typeof localizationInterceptor !== 'undefined') {
      axios.interceptors.request.eject(localizationInterceptor);
    }
    localizationInterceptor = axios.interceptors.request.use(
      function (config) {
        const { params, method } = config;
        if (method === 'get') {
          config.params = { ...params, lang: language };
        }
        return config;
      },
      function (error) {
        return Promise.reject(error);
      }
    );
  } else {
    axios.interceptors.request.eject(localizationInterceptor);
  }
};
